<mat-dialog-content class="diolog-content-change-password">
    <h2 mat-dialog-title>Altere sua senha</h2>
    <p class="sub-title">Informe nos campos abaixo a nova senha desejada.</p>

    <form class="full-width form-fields-gap" [formGroup]="form">
        <mat-form-field class="full-width" appearance="outline">
            <input matInput placeholder="Senha atual" [type]="hideCurrentPassword ? 'password' : 'text'"
                formControlName="currentPassword" />
            <mat-icon matSuffix (click)="hideCurrentPassword = !hideCurrentPassword">{{ hideCurrentPassword ?
                "visibility_off" : "visibility" }}</mat-icon>
            <mat-hint *ngIf="!currentPassword.value">Entre com a última senha que recebeu em seu e-mail</mat-hint>
        </mat-form-field>

        <mat-form-field class="full-width" appearance="outline">
            <input matInput placeholder="Nova senha" [type]="hideNewPassword ? 'password' : 'text'"
                formControlName="newPassword" [class.invalid]="
          (passwordTouched && newPassword?.invalid) || passwordsMismatch
        " (focus)="form.get('password')?.markAsTouched()" />
            <mat-icon matSuffix (click)="hideNewPassword = !hideNewPassword">{{
                hideNewPassword ? "visibility_off" : "visibility"
                }}</mat-icon>
            <mat-hint *ngIf="!newPassword.value">Entre com a nova senha</mat-hint>
        </mat-form-field>

        <mat-form-field class="full-width" appearance="outline">
            <input matInput placeholder="Confirme nova senha" [type]="hideConfirmPassword ? 'password' : 'text'"
                formControlName="confirmPassword" [class.invalid]="passwordTouched && newPassword?.invalid" />
            <mat-icon matSuffix (click)="hideConfirmPassword = !hideConfirmPassword">{{ hideConfirmPassword ?
                "visibility_off" : "visibility" }}</mat-icon>
            <mat-hint *ngIf="!confirmPassword.value">Confirme a nova senha</mat-hint>
        </mat-form-field>
        <mat-error *ngIf="passwordsMismatch"> As senhas não coincidem. </mat-error>

        <ul class="validation-list">
            <li class="criteria-title">Senha deve conter:</li>
            <li [class.valid]="!passwordErrors.minLength">Mínimo de 8 caracteres</li>
            <li [class.valid]="!passwordErrors.uppercase">1 letra maiúscula (A–Z)</li>
            <li [class.valid]="!passwordErrors.lowercase">1 letra minúscula (a–z)</li>
            <li [class.valid]="!passwordErrors.number">1 número (0–9)</li>
            <li [class.valid]="!passwordErrors.special">
                1 caractere especial (@, #, $, %, etc.)
            </li>
        </ul>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="conter">
    <div class="center-footer-modal">
        <button mat-raised-button color="primary" class="full-width" (click)="updatePassword()"
            [disabled]="form.invalid">
            Salvar nova senha
        </button>
        <div class="resend-code">
            <span [class.disabled]="isDisabled" (click)="reset()">
                {{
                isDisabled
                ? "Reenviar em " + countdown + "s"
                : "Enviar email com uma nova senha"
                }}
            </span>
        </div>
    </div>
</mat-dialog-actions>